const productionConfig = {
  env: 'production',
  baseApiURL: process.env.REACT_APP_BASE_API_URL,
  appURL: process.env.REACT_APP_BASE_URL,
};

export default productionConfig;
